import axios from 'axios'

const axiosObj = axios.create({
  baseURL: `${process.env.REACT_APP_ADMIN_BASE_URL}/v1`,
  headers: {
    'Content-Type': 'application/json'
  },
  responseType: 'json'
})

const toolTypeService = {
  getToolTypes: async (data) => {
    try {
      const response = await axiosObj.get('/tool-type')

      return response.data
    } catch (err) {
      console.log(err)
      return err.response
    }
  },
  addToolType: async (data) => {
    try {
      const response = await axiosObj.post('/tool-type', data)
      return response
    } catch (err) {
      console.log(err)
      return err.response
    }
  },
  editToolType: async (id, data) => {
    try {
      const response = await axiosObj.put(`/tool-type/${id}`, data)
      return response
    } catch (err) {
      console.log(err)
      return err.response
    }
  },
  deleteToolType: async (id, data) => {
    try {
      const response = await axiosObj.delete(`/tool-type/${id}`, data)
      return response
    } catch (err) {
      console.log(err)
      return err.response
    }
  }
}

export default toolTypeService
